export default import.meta.ROLLDOWN_FILE_URL_5jpZzjd8NgMb4PjyyBSg$w